<template>
    <div>
       <app-new-breadcrumb :id="this.id" :routesName="this.$t('oldCurrencySavingsRouteName')"></app-new-breadcrumb>
        
        <div class="main-content">
            <div class="page-inner">
            <div class="col-12 pr-0">
                <!-- <app-document-content v-for="menuItem in getChildrenByParentId(id, true)"
                    v-bind:content="getContentById(menuItem.id)">
                </app-document-content> -->
                <app-document-content v-for="menuItem in paginatedChildren" :key="menuItem.id"
                    :content="getContentById(menuItem.id)">
                </app-document-content>
            </div>
            </div>
        </div>
        <div class="col-md-12 text-center pagination-container">
            <app-paginate v-model="searchObject.currentPage" :page-count="searchObject.numberOfPages"
                :click-handler="changePage" :prev-text="$t('previous')" :next-text="$t('next')"
                :container-class="'pagination'" :page-class="'page-item'" :page-link-class="'page-link small'"
                :next-class="'page-item'" :next-link-class="'page-link small'" :prev-class="'page-item'"
                :prev-link-class="'page-link small'" :page-range="3" :margin-pages="1">
            </app-paginate>
        </div>

    </div>
</template>

<script>
import SideMenuItem from '../menu/SideMenuItem'
import NewsContent from '../content/NewsContent'
import DocumentContent from '../content/DocumentContentNew'
import { mapGetters } from 'vuex'
import Paginate from 'vuejs-paginate'
import Breadcrumb from "../common/Breadcrumb.vue";

export default {
    data() {
        return {
            hierarchyLevel: 1,
            defaultIndent: 10,
            searchObject: {
                currentPage: 1,
                pageSize: 5, 
                numberOfPages: 1,
                totalRecords: 0
            },
        }
    },
    components: {
        appNewsContent: NewsContent,
        appDocumentContent: DocumentContent,
        appSideMenuItem: SideMenuItem,
        appPaginate: Paginate,
        appNewBreadcrumb: Breadcrumb,

    },
    props: ["id"],
    computed: {
        ...mapGetters(["getChildrenByParentId", "getContentById", "hasContentChildren"]),
        paginatedChildren() {
            const startIndex = (this.searchObject.currentPage - 1) * this.searchObject.pageSize;
            const endIndex = startIndex + this.searchObject.pageSize;
            const sortedChildren = this.getChildrenByParentId(this.id, true).sort((a, b) => b.ordinalNumber - a.ordinalNumber);
            return sortedChildren.slice(startIndex, endIndex);
        },

        getPaginationInfo() {
            var start = ((this.searchObject.currentPage - 1) * this.searchObject.pageSize) + 1;
            var end = Math.min(start + this.searchObject.pageSize - 1, this.searchObject.totalRecords);
            return [start, end, this.searchObject.totalRecords];
        }
    },
    methods: {
       
        changePage(page) {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 1000); // Adjust time as needed
            this.searchObject.currentPage = page;
        },

        updatePaginationInfo() {
            const totalRecords = this.getChildrenByParentId(this.id, true).length;
            this.searchObject.totalRecords = totalRecords;
            this.searchObject.numberOfPages = Math.ceil(totalRecords / this.searchObject.pageSize);
        }
    },
    created() {
        this.updatePaginationInfo();
    },
    watch: {
        id() {
            this.updatePaginationInfo();
        },
    }
}
</script>

<style scoped>
.main-content {
    padding: 0% 7%;
    box-sizing: border-box;
}
.content-menu-title {
    background-color: #FFF;
    padding: 2%;
    color: var(--main-color);
    box-shadow: 0px 2px 6px 1px rgba(0, 0, 0, 0.15);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    /* Optional, adds spacing between the content and pagination */
}

.pagination {
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
